import { render } from "./World.vue?vue&type=template&id=58381d54"
import script from "./World.vue?vue&type=script&lang=js"
export * from "./World.vue?vue&type=script&lang=js"

import "./World.vue?vue&type=style&index=0&id=58381d54&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__